<button
	class="slide-toggle"
	[class.slide-toggle--checked]="checked"
	[class.slide-toggle--disabled]="disabled"
	[attr.aria-label]="ariaLabel"
	[attr.aria-labelledby]="ariaLabelledby"
	[attr.aria-checked]="checked"
	[disabled]="disabled"
	role="switch"
	type="button"
	(click)="toggle()">
	<span class="slide-toggle__track">
		<span class="slide-toggle__thumb">
			<!-- Checkmark icon when checked -->
			<svg
				*ngIf="checked"
				class="slide-toggle__icon slide-toggle__icon--check"
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M13 4L6 11L3 8"
					stroke="var(--brandPrimary)"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
			</svg>
			<!-- X icon when unchecked -->
			<svg
				*ngIf="!checked"
				class="slide-toggle__icon slide-toggle__icon--close"
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12 4L4 12M12 12L4 4"
					stroke="var(--brandPrimary)"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
			</svg>
		</span>
	</span>
</button>
